<template>
  <div
    v-cloak
    id="app"
    v-loading="$store.state.isloading"
    style="overflow: auto"
    :class="$store.state.visvalTheme"
    :element-loading-text="$t('header.dosending')"
  >
    <router-view v-if="$store.state.isRouterAlive" />
    <!-- <socketModel /> -->
    <div
      id="systemNoticesTipsWindow"
      class="selfDialogMask"
      style="display: none"
      @click="systemNoticesTipsWindowClose(true)"
    >
      <div class="selfDialogPlane">
        <div class="selfDialogPlaneHeader">
          {{ $t("base.notice") }}
        </div>
        <img
          v-if="onlineTipsImgsrc != null"
          class="Dialogimg"
          :src="onlineTipsImgsrc"
        >
        <div
          class="Dialogimg"
          style="color: #949494" 
          v-html="systemNoticesTipsWindowText()"
        />
        <div class="Dialogimg">
          <button
            class="slefButtonBlue"
            @click.stop="systemNoticesTipsOK()"
          >
            {{ $t("home.onlineTipsOKtext") }}
          </button>
        </div>
      </div>
    </div>
    <div
      id="onlineTipsWindow"
      class="selfDialogMask"
      style="display:none;"
    >
      <div class="selfDialogPlane">
        <div class="selfDialogPlaneHeader">
          {{ $t("home.onlineTipsHeaderTitle") }}
        </div>
        <img
          v-if="onlineTipsImgsrc != null"
          class="Dialogimg"
          :src="onlineTipsImgsrc"
        >
        <div
          class="Dialogimg"
          style="color: #949494"
        >
          {{ $t("home.onlineTipsDescribe") }}
        </div>
        <div class="Dialogimg">
          <button
            class="slefButtonBlue"
            @click.stop="onlineTipsWindowClose(true)"
          >
            {{ $t("home.onlineTipsOKtext") }}
          </button>
        </div>
      </div>
    </div>
    <!-- <remote-js :srcArr="baiduSrcArr" @scriptLoad="callbackFn" ></remote-js> -->

    <remote-js 
      v-if="isIot3() || isIot1()"
      :key="$store.state.lang"
      :src-arr="googleSrcArr"
      @scriptLoad="callbackFn"
    />
    <OppleModal
      :title="$t('sylogs.error')"
      :visible="$store.state.globalModalData.isShow"
      :is-show-cancel-btn="false"
      @onOk="modalClose"
      @onClose="modalClose"
    >
      {{ $store.state.globalModalData.text }}
    </OppleModal>
  </div>
</template>

<script>
// import wx from 'weixin-js-sdk'
import { GetBaseData ,GetBaseIpRegion} from '@/axios/ICommon.js'
import { GetAllDeviceCategoryList } from '@/axios/IDevice.js'
import { FindUserAreaTree } from '@/axios/IArea'
import { alerterror } from '@/assets/js/common.js'
import { addResizeEvent } from '@/page/control-ts/scene/sceneHandle/indexFns'
import { jumpWithQueriesToLogin } from '@utils/jumpWithQueriesToLogin'
import { tuiLog } from '@/assets/js/api.js'
import { isIot3,isIot1 } from "@utils/utils";
import { buildGoogleMapsScriptUrl } from '@/utils/googleMapsLocale';
import OppleModal from '@/components/OppleModal/index.vue'
import store from './store'
import router from './router'

export default {
  name: 'App',
  components: {
    OppleModal
  },
  data () {
    return {
      onlineTipsImgsrc: null,
      googleMapsApiKey: 'AIzaSyBYo1i-IRDmb0gyTuBY9Xjl9MmlQaM9t0Y'
      // baiduSrcArr: ['https://api.map.baidu.com/api?v=1.0&&type=webgl&ak=Hq62qdls07Hk6OqEGXoqPG24ckgiZQA8']
    }
  },
  computed: {
    googleSrcArr() {
      return [buildGoogleMapsScriptUrl({
        apiKey: this.googleMapsApiKey,
        lang: this.$store.state.lang
      })];
    }
  },
  async created () {
    // this.judgeLoadScript();
    addResizeEvent(this);
    const ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）

      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        this.$store.state.isWXApp = true
      } else {
        this.$store.state.isWXApp = false
      }

      // wx.miniProgram.getEnv((res)=>{
      //
      //   if (res.miniprogram) {
      //       // console.log("在小程序里");
      //       // 判断是否在ios端
      //       if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //
      //         this.$store.state.isWXApp = res.miniprogram;
      //         // wx.config({
      //         //     debug: true, // 调试时可开启
      //         //     appId: 'wx74f9d304cb03875b', // 小程序 AppID<!-- replace -->
      //         //     timestamp: 0, // 必填，填任意数字即可
      //         //     nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
      //         //     signature: 'signature', // 必填，填任意非空字符串即可
      //         //     jsApiList: ['checkJsApi','getLocation'], // 必填，随意一个接口即可
      //         //     openTagList:['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
      //         // })
      //       }else{
      //         // this.createScriptBaidiu();
      //       }
      //   } else {
      //     // console.log("不在小程序里");
      //     // this.createScriptBaidiu();
      //   }
      // },(err)=>{
      //
      //   // console.log("在微信里，获取失败wx.miniProgram.getEnv");
      //   // this.createScriptBaidiu();
      // })
    } else {
      this.$store.state.isWXApp = false

      // console.log('不在微信里');
      // this.createScriptBaidiu();
    }
    // if(this.$store.state.ipConfigOpen){
    //   await this.doGetBaseIpRegion()
    // }
  },
  mounted () {
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
    this.doGetBaseData()
    this.doGetDeviceCategoryListByClassSku()
    // this.doGetDeiveStatusList();
    // jumpWithParams(this.$store, () => {
    //   this.verificationblank(this)
    // })
    jumpWithQueriesToLogin(this.$store, () => {
      this.verificationblank(this)
    })
    this.doFindUserAreaTree()

    this.changFont()

    // if(window["isLocal_node_modules"]){

    // }
  },
  methods: {
    isIot3,
    isIot1,
    callbackFn() {},
    modalClose() {
      store.commit('setGlobalModalData', {msg:'',isShow:false})
      router.push({
        name: 'login',
      })
    },
    /* 切换字体 */
    changFont() {
      window.document.documentElement.setAttribute('data-theme', getLocalStoragItem('lang'))
    },
    // createScriptBaidiu(){
    //   window.HOST_TYPE = "2";
    //   window.BMap_loadScriptTime = (new Date).getTime();
    //   var script = document.createElement("script");
    //   script.type = "text/javascript";
    //   script.src = "https://debug1.opple.com/static/getscriptBaidu.js";
    //   // script.src = "https://debug1.opple.com/baiduapi/getscript?v=2.0&ak=bKmMydK9AwCCC3nKgmpzlgMGrELW30DH&services=&t="+window.BMap_loadScriptTime;
    //   document.body.appendChild(script);
    // },
    // async judgeLoadScript(){
    //
    //   await this.isWeChatApplet().then((e)=>{
    //
    //   });
    //
    // },
    // /**
    //  * 判断是否为微信小程序
    //  *
    //  * @export
    //  * @returns
    //  */
    // isWeChatApplet() {
    //
    //   const ua = window.navigator.userAgent.toLowerCase();
    //   return new Promise((resolve) => {
    //     if (ua.indexOf('micromessenger') == -1) {//不在微信或者小程序中
    //
    //       resolve(false);
    //     } else {
    //       wx.miniProgram.getEnv((res) => {
    //
    //         if ((/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) &&
    //           res.miniprogram) {//在小程序中 (苹果)
    //           resolve(true);
    //         } else {//在微信中
    //           resolve(false);
    //         }
    //       });
    //     }
    //   });
    // },
    systemNoticesTipsWindowText () {
      let notice = this.$store
      notice = notice && notice.state
      notice = notice && notice.systemNotices
      let _url = this.$router.history.pending
      _url = _url || this.$route
      if (notice != null && _url != null && _url.fullPath != null) {
        notice = notice.find(url => { return url.path != null && url.path == _url.fullPath })
        if (notice != null) { return notice.info }
      }
      _url = null
      notice = null
      return ''
    },
    systemNoticesTipsOK () {
      let notice = this.$store
      notice = notice && notice.state
      notice = notice && notice.systemNotices
      let _url = this.$router.history.pending
      _url = _url || this.$route
      if (notice != null && _url != null && _url.fullPath != null) {
        notice = notice.find(url => { return url.path != null && url.path == _url.fullPath })

        if (notice != null) {
          notice.disabled = true
          _url = window.localStorage
          _url = _url && _url.getItem('systemNotices')
          if (_url != null && !JSON.isJSON(_url)) { _url = null }
          _url = _url && JSON.parse(_url)
          if (_url == null) {
            _url = [notice.path]
            _url = JSON.stringify(_url)
            window.localStorage.setItem('systemNotices', _url)
          } else if (_url.indexOf(notice.path) < 0) {
            _url.push(notice.path)
            _url = JSON.stringify(_url)
            window.localStorage.setItem('systemNotices', _url)
          }
        }
      }
      _url = null
      notice = null
      this.systemNoticesTipsWindowClose(true)
    },
    updateOnlineStatus (e) {
      if (e != null && e.type === 'online') {
        this.onlineTipsWindowClose(true)
      } else {
        this.onlineTipsWindowClose(false)
      }

      tuiLog("[Log WindowEvent online/offline]→" + JSON.stringify({
        type: e.type
      }))
    },
    onlineTipsWindowClose (param) {
      document.getElementById('onlineTipsWindow').style.display = param ? 'none' : 'flex'
    },
    doGetDeviceCategoryListByClassSku () {
      GetAllDeviceCategoryList(this.functionDpGetDeviceCategoryListByClassSku)
    },
    functionDpGetDeviceCategoryListByClassSku (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.$store.dispatch('changeDeviceCategoryList', rs.Result)
      }
    },
    // dunctionDoGetDeiveStatusList(rs){
    // 	if (rs.StatusCode == this.$store.state.rightStatusCode) {
    // 		this.$store.dispatch('changeDeiveStatus', rs.Result);
    // 	}
    // },
    // doGetDeiveStatusList(){
    // 	//获取设备状态列表
    // 	GetDeiveStatusList(this.dunctionDoGetDeiveStatusList);
    // },
    doGetBaseData () {
      // 获取基础集合列表
      GetBaseData({appType:4},this.dunctionDoGetBaseData)
    },
    dunctionDoGetBaseData (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        // if(_param["SystemStatusList"] instanceof Array){this.$store.dispatch('changeErrorInfor', _param["SystemStatusList"]);}
        // if(_param["DeiveStatusList"] instanceof Array){this.$store.dispatch('changeDeiveStatus', _param["DeiveStatusList"]);}
        // if(_param["EventTypeList"] instanceof Array){}
        let _param = rs.Result
        if (_param == null) { return }
        this.$store.dispatch('changeBaseData', _param)
        if (_param.PowerPerfix != null) { this.$store.dispatch('changePowerPerfix', _param.PowerPerfix) }
        if (_param.DeiveStatusList instanceof Array) { 
          setLocalStoragItem('DeiveStatusList',JSON.stringify(_param.DeiveStatusList))
          this.$store.dispatch('changeDeiveStatus', _param.DeiveStatusList) }
        if (_param.SystemStatusList instanceof Array) { this.$store.dispatch('changeErrorInfor', _param.SystemStatusList) }
        if (_param.DeviceTypeList instanceof Array) { this.$store.dispatch('changeDeviceType', _param.DeviceTypeList) }
        if (_param.ProtocolTypeList instanceof Array) { this.$store.dispatch('changeProtocolType', _param.ProtocolTypeList) }
        if (_param.DeviceLogLevel instanceof Array) { this.$store.dispatch('changeDeviceLogLevel', _param.DeviceLogLevel) }
        if (_param.SystemModuleList instanceof Array) { this.$store.dispatch('changeSystemModule', _param.SystemModuleList) }
        if (_param.UserActionTypeList instanceof Array) { this.$store.dispatch('changeUserActionType', _param.UserActionTypeList) }
        this.doGetBaseIpRegion(_param.CountryList)
        _param = null
      } else {
        alerterror(this, rs.StatusCode)
      }
    },
    // 获取基础IP信息
    doGetBaseIpRegion(Result){
      if(Result && Array.isArray(Result) && Result.length > 0){
        const ipRegion = Result.reduce((acc, cur) => {
          if(cur.IpRegion && cur.IpRegion?.ShortName){
            acc[cur.IpRegion.ShortName] = cur.IpRegion
          }
          return acc
        }, {})
        this.$store.dispatch('changeIpRegion', ipRegion)
      }
    },
    doFindUserAreaTree () {
      if (this.$store.state.projectcode != null && this.$store.state.projectcode != '') {
        FindUserAreaTree({ nojump: true }, this.functionDoFindUserAreaTree)
      }
    },
    functionDoFindUserAreaTree (rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result != null && rs.Result.length > 0) {
          rs.Result.forEach(item => {
            this.addArry(item)
          })
        }
      }
    },
    addArry (model) {
      this.$store.dispatch('updateGpName', { Gpno: model.Gpno, GpName: model.GpName, Level: model.Level })
      if (model.Childs != null && model.Chi2lds && model.Chi2lds.length > 0) {
        model.Childs.forEach((item, index) => {
          this.addArry(item)
        })
      }
    }
  }
}
</script>

<style>
@import "./assets/css/main.scss";
@import "./assets/css/base.scss";
@import "./assets/css/theme-green/icon.scss";

</style>

<style lang="scss">
@import "./assets/css/theme-green/fonts-variable.scss";
@import "./assets/css/theme-green/fonts-mixin.scss";
@import "./assets/css/de-style.scss";
@import './assets/css/visual-color.scss';
/* 切换字体 */
body * {
  @include font_color($font-def);
}
</style>
